'use strict';
import {extendPrototypeResult as localforage} from 'localforage-indexes';
import moment from 'moment/moment';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/skip';
import {buildInjector} from '../../_libs/angular-utils';
import {ReduxList} from '../../_libs/redux-observable-list';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {sortByPropertyAccessor} from '../../core-utilities/filters/filterUtils';
import {groupByDate} from '../../components/lists/DateHeader';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {buildParentChannelSyncNotifier} from '../../auth/utils/redux-lists';
import * as TASK_TYPE from '../../tasks/enums/TASK_TYPE';
import {COLLECTION as TASK_COLLECTION} from '../../tasks/domain/TaskDomain';
import {COLLECTION as ASSET_TASK_COLLECTION} from '../../tasks/domain/AssetTaskDomain';
import {TIMER_ACTIVITIES_COLLECTION} from '../domain/config';
import {PreviewTimerLogEpics} from '../epics/previewTimerLog';

// load angular dependencies:
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'FirebaseUtil',
]);

export const localForageConfig = {
  name: 'SwiftProjects',
  version: 1,
//  size        : 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName: 'redux-storage-timer-logs',
  description: 'Cache timer logs lists',
  driver: 'lruStorage',
  cacheSize: 50,
  lruIndex: 'redux-storage-timer-logs-idx',
};
export const asyncStorage = localforage.createInstance(localForageConfig);

export function buildTimerLogList(options, targetOptions) {
  const taskCollection = targetOptions.taskType === TASK_TYPE.SITE ? ASSET_TASK_COLLECTION : TASK_COLLECTION;

  const reduxList = new ReduxList({
    ...BASE_REDUX_LIST_OPTIONS,
    hasParentId: true,
    applySortOptions,
    syncNotifier: buildParentChannelSyncNotifier(taskCollection, TIMER_ACTIVITIES_COLLECTION),
    ...options,

    cacheOptions: {
      localForage: asyncStorage,
      getKey: parentId => `timerLog-${parentId}`,
    },
  });

  const previewEpics = new PreviewTimerLogEpics(reduxList.actions, {
    targetCollection: taskCollection,
    getState: options.getState,
  }, options.logger);

  reduxList.epics.addEpics(previewEpics.epics);

  return reduxList;
}

export function applySortOptions(list) {
  return list.sort(sortByPropertyAccessor(getLastUpdatedDate, SortMethod.DESCENDING.val, true));
}

// sort by date, newest first
function getLastUpdatedDate(item) {
  if (!item) {
    return void 0;
  } else {
    return item.end ? item.end : item.start;
  }
}

export const REDUX_OPTIONS = {
  listTransform: groupByDate({
    dateFormatter,
    dateGetter: model => dateFormatter(model.start),
  }),
};

function dateFormatter(date) {
  const d = new Date(date);
  return moment([d.getFullYear(), d.getMonth(), d.getDate()]).valueOf();
}



// WEBPACK FOOTER //
// ./src/js/timers/redux/timerLogConfig.js